import * as React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import Divider from "@mui/joy/Divider";
import Typography from "@mui/joy/Typography";
import { TestLanguage } from "../hooks/testLanguage";
import { MdLocationOn } from "react-icons/md";
import { Link, redirect, useNavigate } from "react-router-dom";
import Drawer2 from "../Pages/Project/Drawer22";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

export default function Projectcard({ i }) {
  const [selected,setSelected]=React.useState()
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  console.log("selected", selected);
  const navigate = useNavigate();
  const closeModal = () => {
    setModalIsOpen(false);
  };

  const { t } = useTranslation();
  const openModal = (data) => {
    console.log("data", data);

setSelected(data)
    setModalIsOpen(true);
    console.log("data", data);
  };
  return (
    <div style={{ direction: t("directions.dir"), }} className="container">
      {i.map((i) => (
        <div className="col-md-4">
          <Link
            style={{ textDecoration: "none" }}
 onClick={() => {
                openModal(i);     // يفتح المودال ويمرر الكائن
              }}
          >
            <Card
              variant="outlined"
              sx={{
                transition: "transform 0.3s ease-in-out",
                padding: "0",
                "&:hover": {
                  transform: "scale(1.050)", // Zoom effect
                  boxShadow: "lg", // optional: add shadow on hover
                },
                margin: "5%",
                display: "block",
                height: "400px",
                fontFamily: "oswald,cairo",

              }}
            >
              <CardOverflow>
                <AspectRatio ratio="2">
                  <img
                    src={`${process.env.REACT_APP_IMAGE}${i.project_image}`}
                    loading="lazy"
                    alt=""
                  />
                </AspectRatio>
              </CardOverflow>
              <CardContent sx={{ padding: "16px" }}>
                <Typography
                  sx={{ fontSize: "20px", fontFamily: 'oswald,cairo' }}
                  level="title-md"
                >
                  {TestLanguage(i, "project_name")}
                </Typography>
                <Typography
                  sx={{ fontWeight: "md", fontSize: "14px", fontFamily: 'oswald,cairo' }}
                  level="body-sm"
                >
                  <MdLocationOn />
                  {TestLanguage(i.city, "name")}{" "}
                  {TestLanguage(i.region, "name")} {TestLanguage(i, "address")}
                </Typography>
                <Typography
                  sx={{ fontWeight: "300", fontSize: "14px", fontFamily: 'oswald,cairo', textAlign: 'justify' }}
                  level="body-sm"
                >
                  {TestLanguage(i, "project_description")}
                </Typography>
              </CardContent>
             
            </Card>
          </Link>
        </div>
      ))}
      {selected && modalIsOpen && (
        <Drawer2
          point={selected?.id}
          isOpen={openModal}
          onClose={closeModal}
        >

          {/* <h2>{TestLanguage(selected, "project_name")}</h2>
          <p>{TestLanguage(selected, "project_description")}</p> */}
        </Drawer2>
      )}
    </div>
  );
}
